module.exports = __webpack_public_path__ + "img/Aqua_icon.a0262cdd.png";